module.exports = __webpack_public_path__ + "static/img/lartneList_img_2.a197391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/lartneList/lartneList_img_2.png
// module id = QVkY
// module chunks = 1